<template>
  <intersect @enter="animate = true" @threshold="[0, 0.25, 0.5, 0.75, 1]">
      <section class="container fadeUp" :class="animate ? 'animate' : ''">
        <div class="head-banner without-links">
      <div class="img-box parallaxe br-12">

        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(itemData, 'media.cover.devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(itemData, 'media.cover.devices.tablet')"
          />
          <img
            :src="_.get(itemData, 'media.cover.devices.desktop')"
            class="img-absolute br-12"
            alt
            v-prlx="{ speed: 0.1 }"
          />
        </picture>
        <div class="gradient br-12"></div>
        <div class="widget-content">
          <!-- <img src="@/assets/img/west.png" alt class="banner-logo" /> -->
          <h1 class="main-title white">{{ itemData.title }}</h1>
          <div class="white">{{ itemData.teaser }}</div>
        </div>
      </div>
    </div>
      </section>
  </intersect>
</template>

<script>
import Vue from 'vue'
import MainMixin from "@/mixins/main";
import AliMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive('prlx', Paralax)

export default {
  mixins: [MainMixin, AliMixin],
  props: ["itemData"],
  components: { Intersect },
  data(){
    return {
      animate:false,
    }
  },

  // computed: {
  //   siblings() {
  //     return this.getMenuFlat("main", this.$store.state.selected_menu.pid);
  //   },
  //   parentMenu() {
  //     return this.getMenuById(this.$store.state.selected_menu.pid);
  //   },
  // },
  mounted() {
    this.startParralaxe();
  },
};
</script>
